module.exports = __webpack_public_path__ + "static/Lane-G-Valiante-ee652fd07c7b334bba1f360e4db62c7a.png";